/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether the given email address is valid and can be used for signing up to Malt,
 * or the reason why it's not.
 * 
 * @export
 */
export const EmailAddressValidity = {
    AlreadyUsed: 'ALREADY_USED',
    UnclaimedComatchAccount: 'UNCLAIMED_COMATCH_ACCOUNT',
    InvalidAddress: 'INVALID_ADDRESS',
    ValidAddress: 'VALID_ADDRESS'
} as const;
export type EmailAddressValidity = typeof EmailAddressValidity[keyof typeof EmailAddressValidity];


export function instanceOfEmailAddressValidity(value: any): boolean {
    for (const key in EmailAddressValidity) {
        if (Object.prototype.hasOwnProperty.call(EmailAddressValidity, key)) {
            // @ts-ignore
            if (EmailAddressValidity[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EmailAddressValidityFromJSON(json: any): EmailAddressValidity {
    return EmailAddressValidityFromJSONTyped(json, false);
}

export function EmailAddressValidityFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailAddressValidity {
    return json as EmailAddressValidity;
}

export function EmailAddressValidityToJSON(value?: EmailAddressValidity | null): any {
    return value as any;
}

